// extracted by mini-css-extract-plugin
module.exports = {"content":"TextSection_content__QmPGq"};